"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandName = exports.BrandImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const brands_1 = require("../../../../utils/helpers/brands");
const manageDate_1 = require("../../../utils/manageDate");
const BrandHeader_styled_1 = require("./BrandHeader.styled");
exports.BrandImage = {
    [brands_1.CurrentBrandEnv.BOT]: 'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/boticario-white.svg',
    [brands_1.CurrentBrandEnv.OUI]: 'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/OUI/logo/logo-white.svg',
    [brands_1.CurrentBrandEnv.EAM]: 'https://gb-assets.grupoboticario.digital/eam/logo/logo-white.svg',
    [brands_1.CurrentBrandEnv.EUD]: 'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/EUD/eudora-white.svg',
    [brands_1.CurrentBrandEnv.MLT]: 'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/boticario-white.svg',
};
exports.BrandName = {
    [brands_1.CurrentBrandEnv.BOT]: 'O Boticário',
    [brands_1.CurrentBrandEnv.OUI]: 'OUI',
    [brands_1.CurrentBrandEnv.EAM]: 'Eu amo make',
    [brands_1.CurrentBrandEnv.EUD]: 'Eudora',
    [brands_1.CurrentBrandEnv.MLT]: 'Grupo Boticário',
};
const BrandHeader = ({ brand = brands_1.CurrentBrandEnv.BOT, cycle }) => {
    const currentBrandName = exports.BrandName[brand];
    const currentBrandImage = exports.BrandImage[brand];
    const currentCycle = `Ciclo ${cycle.number}. De ${(0, manageDate_1.getfullMonthAndYear)(cycle.start)} até ${(0, manageDate_1.getfullMonthAndYear)(cycle.end)}`;
    return ((0, jsx_runtime_1.jsxs)(BrandHeader_styled_1.Container, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Image, { alt: currentBrandName, "aria-label": currentBrandName, src: currentBrandImage }), (0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ "aria-label": currentCycle }, { children: [(0, jsx_runtime_1.jsx)(BrandHeader_styled_1.IconWrapper, Object.assign({ "aria-hidden": true }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.CalendarIcon, { size: 12 }) })), (0, jsx_runtime_1.jsxs)(flora_react_1.Text, Object.assign({ "aria-hidden": true, color: "$nonInteractiveAltPredominant", size: "auxiliarMini" }, { children: ["Ciclo ", cycle.number, " - ", cycle.start, " at\u00E9 ", cycle.end] }))] }))] }));
};
exports.default = BrandHeader;
